import "../jquery-ui";
import 'bootstrap';

function headerDropdowns()  {
  $("#product-dropdown").dropdown();
  $("#account-dropdown").dropdown();
  $("#locale-dropdown").dropdown();
  $("#resources-dropdown").dropdown();

  function enableFloating(selector) {
    $(`#${selector}-dropdown`).on('mouseenter', function () {
      if (!$(`.${selector}-menu`).hasClass('show')) $(this).dropdown('toggle');
    })
  
    $(`#${selector}-dropdown`).on('mouseleave', function () {
      setTimeout(() => {
        if (!$(`.${selector}-menu:hover`).length && !$(`#${selector}-dropdown:hover`).length) $(`#${selector}-dropdown`).dropdown('toggle');
      }, 100)
    })
  
    $(`.${selector}-menu`).on('mouseleave', function(){
      if($(`.${selector}-menu`).hasClass('show')) $(this).dropdown('toggle');
    })
  }

  enableFloating('product');
  enableFloating('resources');
}

headerDropdowns();
